import { jsxs, jsx } from "react/jsx-runtime";
import React__default, { useState, useEffect, forwardRef, useRef, useImperativeHandle } from "react";
import { c as clsx } from "../../../../../chunks/clsx-DgYk2OaC.js";
import { TextInput } from "../../../elements/TextInput/TextInput.js";
import { Description } from "../internal/Description/Description.js";
import { Label } from "../internal/Description/Label/Label.js";
import { j as $431fbd86ca7dc216$export$f21a1ffae260145a } from "../../../../../chunks/utils-CXpO-7ST.js";
import { $ as $3ef42575df84b30b$export$9d1611c77c2fe928 } from "../../../../../chunks/mergeProps-bpc4gVdj.js";
import { $ as $65484d02dcb7eb3e$export$457c3d6518dd4c6f } from "../../../../../chunks/filterDOMProps-D2C6R0DK.js";
import { $ as $99facab73266f662$export$5add1d006293d136, a as $e93e671b31057976$export$b8473d3665f3a75a } from "../../../../../chunks/useFormValidation-CIUJuxeV.js";
import { $ as $458b0a5536c1a7cf$export$40bfa8c7b0832715, a as $e5be200c675c3b3a$export$fc1a364ae1f3ff10 } from "../../../../../chunks/useFormValidationState-CYjUuzK3.js";
import { $ as $2baaea4c71418dea$export$294aa081a6c6f55d } from "../../../../../chunks/useField-hKk7NfY9.js";
import { $ as $f645667febf57a63$export$4c014de7c8940b4c } from "../../../../../chunks/useFocusable-Rgl20men.js";
function $2d73ec29415bd339$export$712718f7aec83d5(props, ref) {
  let { inputElementType = "input", isDisabled = false, isRequired = false, isReadOnly = false, type = "text", validationBehavior = "aria" } = props;
  let [value, setValue] = $458b0a5536c1a7cf$export$40bfa8c7b0832715(props.value, props.defaultValue || "", props.onChange);
  let { focusableProps } = $f645667febf57a63$export$4c014de7c8940b4c(props, ref);
  let validationState = $e5be200c675c3b3a$export$fc1a364ae1f3ff10({
    ...props,
    value
  });
  let { isInvalid, validationErrors, validationDetails } = validationState.displayValidation;
  let { labelProps, fieldProps, descriptionProps, errorMessageProps } = $2baaea4c71418dea$export$294aa081a6c6f55d({
    ...props,
    isInvalid,
    errorMessage: props.errorMessage || validationErrors
  });
  let domProps = $65484d02dcb7eb3e$export$457c3d6518dd4c6f(props, {
    labelable: true
  });
  const inputOnlyProps = {
    type,
    pattern: props.pattern
  };
  let [initialValue] = useState(value);
  var _props_defaultValue;
  $99facab73266f662$export$5add1d006293d136(ref, (_props_defaultValue = props.defaultValue) !== null && _props_defaultValue !== void 0 ? _props_defaultValue : initialValue, setValue);
  $e93e671b31057976$export$b8473d3665f3a75a(props, validationState, ref);
  useEffect(() => {
    if (ref.current instanceof $431fbd86ca7dc216$export$f21a1ffae260145a(ref.current).HTMLTextAreaElement) {
      let input = ref.current;
      Object.defineProperty(input, "defaultValue", {
        get: () => input.value,
        set: () => {
        },
        configurable: true
      });
    }
  }, [
    ref
  ]);
  return {
    labelProps,
    inputProps: $3ef42575df84b30b$export$9d1611c77c2fe928(domProps, inputElementType === "input" ? inputOnlyProps : void 0, {
      disabled: isDisabled,
      readOnly: isReadOnly,
      required: isRequired && validationBehavior === "native",
      "aria-required": isRequired && validationBehavior === "aria" || void 0,
      "aria-invalid": isInvalid || void 0,
      "aria-errormessage": props["aria-errormessage"],
      "aria-activedescendant": props["aria-activedescendant"],
      "aria-autocomplete": props["aria-autocomplete"],
      "aria-haspopup": props["aria-haspopup"],
      "aria-controls": props["aria-controls"],
      value,
      onChange: (e) => setValue(e.target.value),
      autoComplete: props.autoComplete,
      autoCapitalize: props.autoCapitalize,
      maxLength: props.maxLength,
      minLength: props.minLength,
      name: props.name,
      form: props.form,
      placeholder: props.placeholder,
      inputMode: props.inputMode,
      autoCorrect: props.autoCorrect,
      spellCheck: props.spellCheck,
      [parseInt(React__default.version, 10) >= 17 ? "enterKeyHint" : "enterkeyhint"]: props.enterKeyHint,
      // Clipboard events
      onCopy: props.onCopy,
      onCut: props.onCut,
      onPaste: props.onPaste,
      // Composition events
      onCompositionEnd: props.onCompositionEnd,
      onCompositionStart: props.onCompositionStart,
      onCompositionUpdate: props.onCompositionUpdate,
      // Selection events
      onSelect: props.onSelect,
      // Input events
      onBeforeInput: props.onBeforeInput,
      onInput: props.onInput,
      ...focusableProps,
      ...fieldProps
    }),
    descriptionProps,
    errorMessageProps,
    isInvalid,
    validationErrors,
    validationDetails
  };
}
const textFieldInner = "_textFieldInner_140kt_1";
const textfieldLabel = "_textfieldLabel_140kt_9";
const styles = {
  textFieldInner,
  "textfieldInput-up": "_textfieldInput-up_140kt_5",
  textfieldLabel,
  "textfieldLabel-up": "_textfieldLabel-up_140kt_18"
};
const TextField = forwardRef(
  (props, forwardedRef) => {
    const {
      label,
      required,
      readonly,
      description,
      onBlur,
      patternMismatchMessage,
      valueMissingMessage
    } = props;
    const inputRef = useRef(null);
    useImperativeHandle(forwardedRef, () => inputRef.current, []);
    const [isSuccess, setIsSuccess] = useState(false);
    const [isError, setIsError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [hasFocusOrValue, setHasFocusOrValue] = useState(
      !!props.value || !!props.defaultValue || false
    );
    const textFieldProps = $2d73ec29415bd339$export$712718f7aec83d5(
      {
        ...props,
        isInvalid: isError,
        isReadOnly: readonly,
        onFocus: () => {
          setHasFocusOrValue(true);
        },
        onBlur: (e) => {
          var _a;
          const { valid, valueMissing, patternMismatch } = e.target.validity;
          setHasFocusOrValue(((_a = e.target.value) == null ? void 0 : _a.length) > 0);
          if (valid) {
            setIsSuccess(!e.target.readOnly);
            setIsError(false);
          } else {
            setIsSuccess(false);
            setIsError(true);
            setErrorMessage(
              valueMissing && valueMissingMessage || patternMismatch && patternMismatchMessage || ""
            );
          }
          onBlur == null ? void 0 : onBlur(e);
        }
      },
      inputRef
    );
    return /* @__PURE__ */ jsxs("div", { className: props.className, children: [
      /* @__PURE__ */ jsxs("div", { className: styles.textFieldInner, children: [
        /* @__PURE__ */ jsx(
          Label,
          {
            ...textFieldProps.labelProps,
            className: clsx(styles.textfieldLabel, hasFocusOrValue && styles["textfieldLabel-up"]),
            isError,
            isRequired: required,
            optionalLabelText: props.optionalLabelText,
            children: label
          }
        ),
        /* @__PURE__ */ jsx(
          TextInput,
          {
            ...textFieldProps.inputProps,
            ref: inputRef,
            className: clsx(hasFocusOrValue && styles["textfieldInput-up"]),
            required,
            isError,
            isSuccess
          }
        )
      ] }),
      description && /* @__PURE__ */ jsx(Description, { variant: "default", ...textFieldProps.descriptionProps, children: description }),
      isError && /* @__PURE__ */ jsx(Description, { variant: "error", ...textFieldProps.errorMessageProps, children: errorMessage })
    ] });
  }
);
export {
  TextField
};
